import { styled } from '@mui/system'
import Typography from '../../atoms/typography'

const shouldForwardProp = (prop) => !['skeletonProps', 'sliderProps', 'showTitle', 'tileProps'].includes(prop)

const Root = styled('div', { shouldForwardProp })`
	position: relative;
	padding: 60px ${({ theme }) => theme.spacing(3)} 0;
	${({ theme }) => theme.breakpoints.up('sm')} {
		padding: 80px ${({ theme }) => theme.spacing(5)} 0;
	}
`

const Title = styled(Typography)`
	width: 100%;
	text-align: left;
	margin-bottom: ${({ theme }) => theme.spacing(3)};
	font-size: ${({ theme }) => theme.typography.pxToRem(24)};
	${({ theme }) => theme.breakpoints.up('sm')} {
		margin-bottom: 0;
		width: auto;
		font-size: ${({ theme }) => theme.typography.pxToRem(28)};
	}
`
export { Root, Title }
